import { regions } from "@smash-sdk/core";



export function matchDataCenter(userCountryCode: string) {
    const supportedCountries = [];
    for (const region in regions) {
        switch (regions[region]) {
            case 'eu-west-1': // ireland IE
                supportedCountries.push('IE')
                break;
            case 'eu-west-2': // royaume uni GB
                supportedCountries.push('GB')
                break;
            case 'eu-west-3': // france FR
                supportedCountries.push('FR')
                break;
            case 'eu-central-1': // germany de
                supportedCountries.push('DE')
                break;
            case 'ca-central-1': // canada CA
                supportedCountries.push('CA')
                break;
            case 'us-east-1': // USA
            case 'us-east-2': // USA
            case 'us-west-1': // USA
            case 'us-west-2': // USA
                supportedCountries.push('US')
                break;
        }
    }

    // is user in supported countries ?
    if (supportedCountries.find(sc => sc === userCountryCode)) {
        return { supportedCountry: true, value: supportedCountries.find(sc => sc === userCountryCode) }
    }
    // is user in europe ?
    const euCountryCode = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'GR', 'CH'];
    if (euCountryCode.find(eucc => eucc === userCountryCode)) {
        return { supportedCountry: false, value: 'UE' };
    }

    // not supported
    return { supportedCountry: false, value: null };

}

